import React from 'react';
import SignUpView from './views/SignupView';
import { useParams } from 'react-router-dom';
import { useSignUp } from './hooks/Signup.hook';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

const SignUpController = () => {
  const { email } = useParams();
  const {
    loading,
    error,
    success,
    showModal,
    goHome,
    googleError,
    closeModal,
    loginType,
    handleSubmit,
    loginWithGoogleOAuth,
  } = useSignUp();
  const languageData = useSelector(state => state.lenguage?.lang);
  const initialValues = {
    email: email ? email : '',
    password: '',
    name: '',
    lastname: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email(languageData === 'EN' ? 'Invalid email' : 'Email inválido')
      .required(languageData === 'EN' ? 'Required' : 'Requerido'),
    password: Yup.string()
      .min(
        8,
        languageData === 'EN' ? 'Minimum 8 characters' : 'Mínimo 8 caracteres',
      )
      .required(languageData === 'EN' ? 'Required' : 'Requerido'),
    name: Yup.string().required(
      languageData === 'EN' ? 'Required' : 'Requerido',
    ),
    lastname: Yup.string().required(
      languageData === 'EN' ? 'Required' : 'Requerido',
    ),
  });

  const handleRegister = () => {
    console.log('Redirigiendo a registro...');
  };

  const handleBack = () => {
    window.history.back();
  };

  const handleGoogleLogin = async ({ email, googleToken }) => {
    return loginWithGoogleOAuth({ username: email, googleToken });
  };

  return (
    <SignUpView
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { resetForm }) => handleSubmit(values, resetForm)}
      loading={loading}
      error={error}
      success={success}
      languageData={languageData}
      googleError={googleError}
      onBack={handleBack}
      onRegister={handleRegister}
      onGoogleLogin={handleGoogleLogin}
      showModal={showModal}
      goHome={goHome}
      closeModal={closeModal}
      loginType={loginType}
    />
  );
};

export default SignUpController;
